import {ActionHandlerBase} from "../action-handler-base";
import {ActionID, AreaType, IDeepLink, IOpenCasinoGameActionPayload} from "@sparkware/uc-sdk-core";
import { OrbitAIFeatureAnalyticsCategory } from "../../../analytics/analytics.service.interface";

export class OpenCasinoGameActionHandler extends ActionHandlerBase<IOpenCasinoGameActionPayload> {
    async handle(payload: IOpenCasinoGameActionPayload): Promise<void> {

        const gameType = payload.actionData.gameType;

        if(payload.actionData.isReal) {
            if(!await this.services.user.ensureUserIsLoggedIn('OpenCasinoGameActionHandler')){
                return;
            }
        }

        await this.services.games.getGamesMapUpdatePromise();

        const gameInfo = await this.services.games.getUnrestrictedGameInfo(gameType);

        if(!gameInfo) {
            this.services.logger.error(`Game type ${gameType} was not found!`);

            if (this._shouldOpenGameInWebApp(gameType)) {

                const unifiedDeepLink: IDeepLink = {
                    area: AreaType.button,
                    actions: [
                        {
                            actionID: ActionID.openCasinoGame,
                            actionData: payload.actionData
                        }
                    ]
                };

                // open webApp deeplink with this game
                this.services.sdk.openHybridLink(`/#deeplink=${encodeURIComponent(JSON.stringify(unifiedDeepLink))}`);
                return;
            }

            this.services.analytics.sendOrbitAIFeatureEvent(OrbitAIFeatureAnalyticsCategory.CorrelatedGamePopUp, 'Game_Unavailable', gameType.toString());
            await this._suggestCorrelatedGame(gameType);
            return;
        }

        await gameInfo.open({
            isRealMode: payload.actionData.isReal
        });
    }


    private _shouldOpenGameInWebApp(gameType: number) {
        return this.services.device.hybrid.isEmbedded &&
            !this.services.sdk.isHybridEmbeddedGame(gameType) &&
            !this.services.regulation.shouldPreventOpenGameOnMobileWeb();
    }

    private async _suggestCorrelatedGame(gameType: number) {
        let suggestedGameType: number;
        const correlatedGames = await this.services.games.getCorrelatedGames(gameType, 10) || [];

        if(correlatedGames?.length > 0) {
            const gamesInfoArray = await this.services.games.getUnrestrictedGamesInfoArray(correlatedGames) || [];

            if (gamesInfoArray?.length > 0) {
                suggestedGameType = gamesInfoArray[0].gameType;
            }
        }

        if (!suggestedGameType) {
            this.services.logger.error(`No correlated in layout games are found for game type ${gameType}, getCorrelatedGames: ${correlatedGames.join(';')}!`);

            const suggestedAIGameTypes = this.services.aiEngine.aiRecommendedGames?.gameTypes || [];

            if (suggestedAIGameTypes.length === 0) {
                this.services.logger.debug(`No correlated in ai suggested games are found for game type ${gameType}`);
                return;
            }
            const randomGameIndex = Math.floor(Math.random() * Math.min(10, suggestedAIGameTypes.length));
            suggestedGameType = suggestedAIGameTypes[randomGameIndex];

            //Check if the chosen GameType is allowed in the game layout
            if (!(await this.services.games.getUnrestrictedGameInfo(suggestedGameType))) {
                return;
            }
        }

        const gamePopup = await this.services.gamePopup;

        await gamePopup.showSuggestedGame(suggestedGameType, this.services.translation.translate("GAME_POPUP_GAME_UNAVAILABLE"), this.services.translation.translate("GAME_POPUP_MAY_LIKE"));
    }

}